export default "__VITE_ASSET__D75NnZ8H__"